import { CircularProgress } from "@material-ui/core";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import useSdk from "../../hooks/useSdk";
import { useStore } from "../../hooks/useStore";
import { PrincipalManager } from "../../layout/PrincipalManager/PrincipalManager";
import {dataReset, dataSetLoading} from "../../redux/actions/dataAction";
import { tabSetUserByIndex } from "../../redux/actions/tabActions";
import { Config, ISearchUser } from "../../store/types/userTypes";
import {UserState} from "../../passapp-sdk/types/userTypes";

type EntryEventProps = {
  search?: ISearchUser;
  config?: Config;
  initialUser?: UserState;
  stateTunnel?: (user: UserState) => void;
  index?: number;
};

//Se encarga de recopilar datos en un solo user
const EntryEvent = ({
  search,
  config,
  initialUser,
  stateTunnel,
  index,
}: EntryEventProps) => {
  const { dataStore } = useStore();
  const dispatch = useDispatch();
  const history = useHistory();
  const { user, error } = useSdk(
    dataStore.search ? dataStore.search : search,
    dataStore.config ? dataStore.config : config,
    dataStore.user ? dataStore.user : initialUser
  );

  useEffect(() => {
    if (user) {
      if (index !== undefined && !initialUser) {
        dispatch(tabSetUserByIndex(index, user));
      }
      setTimeout(() => {
        dispatch(dataSetLoading(false));
        dispatch(dataReset());
      }, 1000);
    }
  }, [user]);

  useEffect(() => {
    if (error) {
      // Sin esto, dataStore.loading queda en true para siempre y todo intento futuro de
      // agregar un tab (escaneo QR o búsqueda manual) se ignora en silencio (ver
      // addTabWithStore en useTabs.ts).
      dispatch(dataSetLoading(false));
      dispatch(dataReset());
      history.goBack();
    }
  }, [error]);

  return (
    <>
      {user ? (
        <PrincipalManager userInitialState={user} stateTunnel={stateTunnel} />
      ) : (
        <div
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </div>
      )}
    </>
  );
};

export default EntryEvent;
